<template>
  <div class="input-wrap">
    <div class="custom-tooltip is-hide">
      <svg xmlns="http://www.w3.org/2000/svg" width="6" height="14" viewBox="0 0 6 14" fill="none">
        <path d="M6 0L6 7L6 14L1.11564 8.30158C0.47366 7.5526 0.47366 6.4474 1.11564 5.69842L6 0Z" fill="#17191C"/>
      </svg>
      사업자등록번호 입력
    </div>
    <label class="label">
      비밀번호 <span v-if="this.showPwdRequired" class="required"/>
    </label>
    <input
        type="text"
        autocomplete="off"
        name="password"
        placeholder="비밀번호를 입력하세요."
        v-model="password.displayVal"
        ref="pwdInput"
        class="ant-like-input"
        @focus="event => this.password.eventHandler.focus(event)"
        @blur="event => this.password.eventHandler.blur(event)"
        @input="event => this.password.eventHandler.input(event)"
        @paste="event => this.password.eventHandler.paste(event)"
        @keyup.enter="event => this.password.eventHandler.enter(event)"
        @keydown="this.password.eventHandler.keyDown"
    >
    <i class="fa-regular fa-key icon-left"/>
    <p v-if="!password.isEmpty" class="checkTxt" :style="pwdCheckTxt">{{ pwdCheckTxt.val }}</p>
    <svg 
      v-if="password.isShow"
      class="eye-icon showPwd"
      @click="password.eyeBtn.masking"
      focusable="false" data-icon="eye" width="1em" height="1em" fill="currentColor" aria-hidden="true" viewBox="64 64 896 896">
      <path d="M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"/>
    </svg>
    <svg focusable="false" data-icon="eye-invisible" width="1em" height="1em" fill="currentColor" aria-hidden="true" viewBox="64 64 896 896"
      v-if="!password.isShow"
      class="eye-icon showPwdslash"
      @click="password.eyeBtn.show"
    >
      <path d="M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z"></path><path d="M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z"/>
    </svg>
  </div>
  <div v-if="showConfirmInput" class="input-wrap">
    <label class="label">
      비밀번호 확인 <span class="required"/>
    </label>
    <input
        type="text"
        autocomplete="off"
        name="password"
        placeholder="비밀번호를 확인해주세요."
        v-model="password.confirm.displayVal"
        ref="pwdConfirmInput"
        class="ant-like-input"
        @focus="event => this.password.confirm.eventHandler.focus(event)"
        @blur="event => this.password.confirm.eventHandler.blur(event)"
        @input="event => this.password.confirm.eventHandler.input(event)"
        @paste="event => this.password.confirm.eventHandler.paste(event)"
        @keyup.enter="event => this.password.confirm.eventHandler.enter(event)"
        @keydown="this.password.confirm.eventHandler.keyDown"
    >
    <i class="fa-regular fa-key icon-left"/>
    <p v-if="!password.confirm.isEmpty" class="checkTxt" :style="correspondTxt" style="margin-bottom: 0">
      {{ correspondTxt.val }}</p>
      <svg 
        v-if="password.confirm.isShow"
        class="eye-icon showPwd"
        @click="password.confirm.eyeBtn.masking"
        focusable="false" data-icon="eye" width="1em" height="1em" fill="currentColor" aria-hidden="true" viewBox="64 64 896 896">
        <path d="M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"/>
      </svg>
      <svg focusable="false" data-icon="eye-invisible" width="1em" height="1em" fill="currentColor" aria-hidden="true" viewBox="64 64 896 896"
          v-if="!password.confirm.isShow"
          class="eye-icon showPwdslash"
          @click="password.confirm.eyeBtn.show"
      >
        <path d="M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z"></path><path d="M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z"/>
      </svg>
  </div>
</template>
<script>
const readOnly = {
  event: {
    pwdChanged: 'pwdChanged',
    enterPressed: 'enterPressed',
    confirmEnterPressed: 'confirmEnterPressed',
  }
}
export default {
  props: {
    showPwdCheckTxt: {
      type: Boolean,
      default: true
    },
    showConfirmInput: {
      type: Boolean,
      default: true
    },
    showPwdRequired: {
      type: Boolean,
      default: true
    }
  },
  emits: Object.keys(readOnly.event),
  computed: {
    pwdCheckTxt() {
      const {validation} = this.password;
      if (validation.includeKorean.val) {
        return {val: '한글은 입력할 수 없습니다.', color: 'red', display: 'block'}
      } else if (!validation.correctRule.val && this.showPwdCheckTxt) {
        return {val: '유효하지 않은 비밀번호 입니다. (영문 숫자 조합으로 8~16자)', color: 'red', display: 'block'}
      } else if (!this.showPwdCheckTxt) {
        return {val: '', color: '', display: 'none'}
      } else {
        return {val: '유효한 비밀번호 입니다.', color: '#1EB851', display: 'block'}
      }
    },
    correspondTxt() {
      const {password} = this
      const condition = password.validation.getCorrespondStatus();
      return {
        color: condition ? '#1EB851' : 'red',
        val: condition ? '비밀번호가 일치합니다.' : '비밀번호가 일치하지 않습니다.'
      }
    },
  },
  data() {
    return {
      password: {
        paramVal: '',
        displayVal: '',
        isEmpty: true,
        isShow: false,
        eyeBtn: {
          show: () => {
            this.password.isShow = true;
            this.password.displayVal = this.password.paramVal;
            this.password.emit();
          },
          masking: () => {
            this.password.isShow = false;
            this.password.displayVal = '●'.repeat(this.password.paramVal.length);
            this.password.emit();
          },
        },
        eventHandler: {
          focus: (event) => {
            if (event.target.value) this.password.isEmpty = false;
          },
          blur: (event) => {
            if (!event.target.value) {
              this.password.isEmpty = true;
            }
          },
          input: (event) => {
            // ⚠️ 로직 순서 유지가 필요함
            // 0
            if (this.password.validation.includeKorean.val) {
              this.password.displayVal = ''
              this.password.paramVal = ''
              this.password.validation.includeKorean.val = false;
              this.password.emit();
              return
            }

            // 1
            const value = event.target.value;
            if (value) this.password.isEmpty = false;

            // 2
            if (this.password.isShow) {
              this.password.displayVal = value;
              this.password.paramVal = value;
              this.password.emit();
            } else {
              this.password.maskingByLetter(event.target.value, event.inputType === 'deleteContentBackward');
            }

            // 3
            const {validation} = this.password;
            validation.alphabetAndNum.check();
            validation.includeKorean.check();
            validation.correctRule.check();
          },
          paste: (event) => {
            // ⚠️로직 순서 유지 필요함
            // 1
            event.preventDefault();
            this.password.isEmpty = false;
            const pastedData = event.clipboardData || window.clipboardData;
            const pastedText = pastedData.getData('text');
            this.password.paramVal = pastedText;

            // 2
            if (this.password.isShow) {
              this.password.displayVal = pastedText;
              this.password.emit();
            } else {
              const maskedPart = "●".repeat(pastedText.length - 1);
              const lastChar = pastedText.charAt(pastedText.length - 1);
              this.password.displayVal = maskedPart + lastChar;
              this.password.emit();
            }

            // 3
            const {validation} = this.password;
            validation.alphabetAndNum.check();
            validation.includeKorean.check();
            validation.correctRule.check();
          },
          enter: (event) => {
            this.$emit(readOnly.event.enterPressed, {paramVal: this.password.paramVal});
          },
          keyDown: (event) => {
            if (this.password.paramVal && event.target.selectionStart === 0 && event.target.selectionEnd === this.password.paramVal.length) {
              event.preventDefault();
              this.password.paramVal = '';
              this.password.displayVal = '';
              this.password.validation.pwdRollback();
              this.password.emit();
            }
          }
        },
        maskingByLetter: (val, isBackSpace) => {
          if (isBackSpace) {
            this.password.paramVal = this.password.paramVal.slice(0, -1);
            this.password.displayVal = '●'.repeat(this.password.paramVal.length);
          } else {
            const lastChar = val.slice(-1);
            this.password.paramVal += lastChar;
            this.password.displayVal = '●'.repeat(this.password.paramVal.length - 1) + lastChar;
          }
          this.password.emit();
        },
        confirm: {
          paramVal: '',
          displayVal: '',
          isEmpty: true,
          isShow: false,
          eyeBtn: {
            show: () => {
              this.password.confirm.isShow = true;
              this.password.confirm.displayVal = this.password.confirm.paramVal;
              this.password.emit();
            },
            masking: () => {
              this.password.confirm.isShow = false;
              this.password.confirm.displayVal = '●'.repeat(this.password.confirm.paramVal.length);
              this.password.emit();
            },
          },
          eventHandler: {
            focus: (event) => {
              if (event.target.value) this.password.confirm.isEmpty = false;
            },
            blur: (event) => {
              if (!event.target.value) {
                this.password.confirm.isEmpty = true;
              }
            },
            input: (event) => {
              // 1
              const value = event.target.value;
              if (value) this.password.confirm.isEmpty = false;

              // 2
              if (this.password.confirm.isShow) {
                this.password.confirm.displayVal = value;
                this.password.confirm.paramVal = value;
                this.password.emit();
              } else {
                this.password.confirm.maskingByLetter(event.target.value, event.inputType === 'deleteContentBackward');
              }
            },
            paste: (event) => {
              // 1
              event.preventDefault();
              this.password.confirm.isEmpty = false;
              const pastedData = event.clipboardData || window.clipboardData;
              const pastedText = pastedData.getData('text');

              // 2
              this.password.confirm.paramVal = pastedText;
              if (this.password.confirm.isShow) {
                this.password.confirm.displayVal = pastedText;
                this.password.emit();
              } else {
                const maskedPart = "●".repeat(pastedText.length - 1);
                const lastChar = pastedText.charAt(pastedText.length - 1);
                this.password.confirm.displayVal = maskedPart + lastChar;
                this.password.emit();
              }
            },
            enter: (event) => {
              this.$emit(readOnly.event.confirmEnterPressed, {paramVal: this.password.confirm.paramVal});
            },
            keyDown: (event) => {
              if (this.password.confirm.paramVal && event.target.selectionStart === 0 && event.target.selectionEnd === this.password.confirm.paramVal.length) {
                event.preventDefault();
                const {value} = event.target;
                this.password.confirm.paramVal = value;
                this.password.confirm.displayVal = value;
                this.password.validation.pwdConfirmRollback();
                this.password.emit();
              }
            }
          },
          maskingByLetter: (val, isBackSpace, isConfirm) => {
            if (isBackSpace) {
              this.password.confirm.paramVal = this.password.confirm.paramVal.slice(0, -1);
              this.password.confirm.displayVal = '●'.repeat(this.password.confirm.paramVal.length);
              this.password.emit();
            } else {
              const lastChar = val.slice(-1);
              this.password.confirm.paramVal += lastChar;
              this.password.confirm.displayVal = '●'.repeat(this.password.confirm.paramVal.length - 1) + lastChar;
              this.password.emit();
            }
          },
        },
        validation: { // ⚠️주의: check()에서 test 함수의 파라미터는 event.target.value 와 this.password.displayVal 은 마스킹된 값이기 때문에 this.password.paramVal 이 되어야 함.
          alphabetAndNum: {
            val: false,
            check: () => this.password.validation.alphabetAndNum.val = /^[A-Za-z0-9]+$/.test(this.password.paramVal)
          },
          correctRule: {
            val: false,
            check: () => this.password.validation.correctRule.val = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]{8,16}$/.test(this.password.paramVal),
          },
          includeKorean: {
            val: false,
            check: () => this.password.validation.includeKorean.val = /[\u3131-\uD79D]/ugi.test(this.password.paramVal),
          },
          pwdRollback: () => {
            this.password.validation.alphabetAndNum.val = false;
            this.password.validation.includeKorean.val = false;
            this.password.validation.correctRule.val = false;
          },
          pwdConfirmRollback: () => {
          },
          getCorrespondStatus: () => {
            let isCorrespond;
            if (this.password.isEmpty) {
              isCorrespond = false
            } else {
              isCorrespond = this.password.paramVal === this.password.confirm.paramVal;
            }
            return isCorrespond;
          },
        },
        emit: () => this.$emit(readOnly.event.pwdChanged, {
          paramVal: this.password.paramVal,
          displayVal: this.password.displayVal,
          confirmParamVal: this.password.confirm.paramVal,
          confirmDisplayVal: this.password.confirm.displayVal,
          isCorrectRule: this.password.validation.correctRule.val,
        })
      },
    }
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.checkTxt {
  padding-top: 5px;
  padding-left: 10px;
  font-size: 14px;
}

.custom-tooltip {
  padding: 6px 8px;
  border-radius: 6px;
  background: #17191C;
  position: absolute;
  top: 25px;
  right: -135px;
  color: white;
  font-family: "Pretendard";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 157.143% */
  &.is-hide {
    display: none;
  }

  svg {
    position: absolute;
    left: -6px;
    top: 10px;
  }
}

.input-wrap {
  margin-bottom: 15.5px;
  position: relative;
  .input-title {
    margin-bottom: 6px;
    line-height: 1.2;
    color: #4B5158;
    letter-spacing: 0;
    font-size: 14px;
    font-weight: 500;
  }
  .label {
    position: relative;
    font-weight: 580;
    font-size: 14px;

    .required {
      position: absolute;
      top: 2px;
      width: 7px;
      height: 7px;
      border-radius: 100%;
      background-color: #FB574B;
      margin-left: 3px;
      display: inline-block;
      margin-bottom: auto;
    }
  }
  input {
    border-radius: 6px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    padding: 12px 16px;
    display: flex;
    flex-wrap: nowrap;
    height: min-content;
    width: 100%;
    max-height: 41px;
    text-indent: 20px;
  }
  .eye-icon {
    position: absolute;
    font-size: 14px;
    color: #8D939A;
    top: 46px;
    right: 15px;
    transition: fill 0.3s ease-in-out;

    &:hover {
      cursor: pointer;
      fill: black;
    }
  }
  .icon-left {
    position: absolute;
    top: 46px;
    left: 16px;
    font-size: 14px;
    color: #8D939A;
  }
}
</style>